module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_industrial_resource.6e540fb7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_industrial_resource.png
// module id = 3003
// module chunks = 11